// src/components/Events.jsx (or wherever it lives)
import EventsSection from "./EventsSection";

function Events() {
    return (
        <main className="page page--contained events-page" aria-labelledby="events-heading">
            <header className="page-header page-header--flush events-header">
                <h1 id="events-heading" className="page-title">Events</h1>
                <p className="page-subtitle events-subtitle">
                    We have ongoing free events, and upcoming Living Rooms in planning!
                </p>
            </header>

            <EventsSection></EventsSection>
        </main>
    );
}

export default Events;
